<template>
  <div class="w-11/12 mx-auto flex-row flex-wrap justify-between font-costea">

    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4 md:mb-0">
        Gestión de áreas
      </h1>

      <div class="flex flex-row items-center">
        <div class="flex flex-row justify-center items-center">
          <select v-model="filtroOrden" class="text-costeaGray px-2 py-1 mx-2 text-t14 rounded-md h-10">
            <option value="0">Ordenar por:</option>
            <option value="1">Menor a mayor</option>
            <option value="2">Mayor a menor</option>
          </select>
        </div>
        <p class="text-costeaGray ml-6 mr-3 text-t14">
          <span class="text-costeaBlack font-medium">{{page}}</span> de <span>{{getPageNumber()}}</span>
        </p>
        <div class="flex flex-row h-full">
          <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50" @click="page--, getPageNumber()" v-if="page != 1"><i class="ri-arrow-left-line"></i></button>
          <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()" v-show="page < getPageNumber()"><i class="ri-arrow-right-line"></i></button>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-2 pb-10">


          <div class="col-start-1 col-end-13 grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-4 sm:grid-cols-2">
              
              <div v-for="area in this.displayedAreas" :key="area.index" class="rounded-md overflow-hidden flex flex-col items-center justify-center bg-white">
                  <div class="relative w-full h-36" :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage(area.picture)}`">
                      <span class="flex flex-row absolute bg-costeaDarkYellow text-white w-auto right-2 top-2 text-t14 p-2 rounded-md">
                          <i class="ri-time-line mr-2"></i>
                          <span>$ <span>{{interNumberFormat(getCostoHoras(area.costo_total_del_area, area.horas_hombre_por_mes, area.numero_de_personas))}}</span> </span>
                      </span>
                  </div>
                  <div class="text-t12 leading-5 text-costeaGray px-5 py-3 border-b-2 border-costeaContainer w-11/12">
                      <h4 class="text-costeaBlack font-medium text-t14 pb-2">{{area.name}}</h4>
                      <p>Costo total del area: <span class="text-costeaBlack font-medium">$ {{interNumberFormat(area.costo_total_del_area)}}</span></p>
                      <p>Días hábiles del mes: <span class="text-costeaBlack font-medium">{{area.dias_habiles_mes}}</span></p>
                      <p>Horas por día: <span class="text-costeaBlack font-medium">{{area.horas_por_dia}}</span></p>
                      <p>Horas hombre al mes: <span class="text-costeaBlack fongt-medium">{{area.horas_hombre_por_mes}}</span></p>
                      <p>Número de personas: <span class="text-costeaBlack font-medium">{{area.numero_de_personas}}</span></p>
                  </div>
                  <div class="flex flex-row w-full justify-end px-5 py-3 text-t14">
                        <button @click="showModalDelete(area.name, area.id)" class="flex items-center justify-center rounded-full bg-gray-100 text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon w-8 h-8">
                            <i class="ri-delete-bin-6-line"></i>
                        </button>
                        <button @click="showModalEdit(area.name, area.id, area.dias_habiles_mes, area.horas_por_dia, area.horas_hombre_por_mes, area.costo_total_del_area, getCostoHoras(area.costo_total_del_area, area.horas_hombre_por_mes, area.numero_de_personas), area.numero_de_personas, area.picture)" class="flex items-center justify-center rounded-full text-costeaGray bg-gray-100 hover:text-costeaPrimary hover:bg-costeaPrimaryDisabled w-8 h-8 ml-2">
                            <i class="ri-edit-line"></i>
                        </button>
                  </div>
              </div>

          </div>
    </div>

    <transition name="fade">
      <component  v-show="this.modalAdd" :is="Add" @closeModalAdd="handleAddCloseModal" @reloadData='reloadData'/>
    </transition>
    <transition name="fade">
      <component :areaOld='editName' :idArea='editId' :diasMes='diasMes' :horasDia='horasDia' :horasHombre='horasHombreMes' :costoTotalArea='costoTotalArea' :costoHoraHombre='costoHoraHombre' :numPersonas='numPersonas' :img='img'  v-show="this.modalEdit" :is="this.edit" @closeModalEdit="handleEditCloseModal" @reloadData='reloadData'/>
    </transition>
    <transition name="fade">
      <component :areaOld='deleteName' :idArea='deleteId' v-show="this.modalDelete" :is="Delete" @closeModalDelete="handleDeleteCloseModal" @reloadData='reloadData'/>
    </transition>

    <buttonAdd @showModal="handleAddOpenModal"/>
  </div>

</template>

<script>
import buttonAdd from '@/components/elements/ButtonAdd.vue'
import componentAdd from '@/components/areas/AddAreas.vue'
import componentEdit from '@/components/areas/EditAreas.vue'
import componentDelete from '@/components/areas/DeleteAreas.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name : "Areas",
    components:{
      buttonAdd,
      componentAdd,
      componentEdit,
      componentDelete
    },
    data(){
      return{
        modalAdd: false,
        modalEdit: false,
        modalDelete: false,
        Add:'componentAdd',
        Delete: 'componentDelete',
        areas:[],
        page: 1,
        pages:[],
        elementsPerPage: 8,
        editName: '',
        editId:'',
        deleteName: '',
        deleteId: '',
        diasMes: '', horasDia: '', horasHombreMes: '', costoTotalArea: '', costoHoraHombre: '', numPersonas: '', img: '',
        secretWord: localStorage.getItem('secret-word') ,
        filtroOrden: '0'
      }
    },
    computed:{
      ...mapState(['costea']),
      displayedAreas(){
        if (this.filtroOrden == "") {
        //console.log(JSON.stringify(this.productos))
        return this.paginate(this.areas);
      } else {
        return this.paginate(this.ordenar);
      }
      },
      edit(){
        if(this.modalEdit === true){
          return 'componentEdit' 
        }else{
          return ''
        }
      },
      ordenar(){
        let data = this.areas
        if(this.filtroOrden == '0'){
          data.sort((a, b) => a.id - b.id)
        }
        //ordenar de menor a mayor y mayor a menor del costo_total_del_area
        if(this.filtroOrden == '1'){
          //ordernar de menor a mayor el costo_total_del_area
          data.sort((a, b) => a.costo_total_del_area - b.costo_total_del_area)
        }
        if(this.filtroOrden == '2'){
          //ordenar de mayor a menor el costo_total_del_area
          data.sort((a, b) => b.costo_total_del_area - a.costo_total_del_area)
        }
        console.log(data)
        return data
      },
    },
    methods:{
      
      interNumberFormat(number){
            let interNF = new Intl.NumberFormat('es-CO');
            let numberDecimals = parseFloat(number)
            numberDecimals = numberDecimals.toFixed(2)
            return interNF.format(numberDecimals)
        },
      //GetInfo
      showImage(imagen){
        if (imagen != null) {
        let imageFromServer = this.costea.protocol + this.secretWord + '.backend.costea.com.co/' + imagen;
        return `background-color: #E6E8ED; background-image: url(' ${imageFromServer} ');`
      } else {
        return ` background-color: #056CF2; background-image: url('/img/costea-placeholder.png');`
      }
      },
      getCostoHoras(costoArea, horasMes, trabajadores){
        let total = costoArea / (horasMes * trabajadores)
        total = total.toFixed(2)
        return total
      },
      getAreas: function(){
          axios
          .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}areasempresa`)
            .then( respuesta => {
                if(respuesta.data.status == false){
                  this.$router.push('/login')
                }
                this.areas = respuesta.data; 
                this.pages = []
                this.setPages()
            }).catch((error) => {
              if(error.response.status === 401){
                this.$router.push('/login')
              }
            })
      },
      reloadData(value){
        if(value === true){
          this.getAreas()
          this.updateParent()
          value = false
        }else{
          console.log('Ocurrio un error')
        }
      },

      
      //Handles
      handleAddOpenModal(value){
        this.modalAdd = value
      },
      handleAddCloseModal(value){
        this.modalAdd = value
      },
      handleEditCloseModal(value){
        this.modalEdit = value
      },
      handleDeleteCloseModal(value){
        this.modalDelete = value
      },
      showModalEdit(catName, catId, diasMes, horasDia, horasHombreMes, costoTotalArea, costoHoraHombre, numPersonas, img){
        if(this.modalEdit === false){
            this.modalEdit = true
            this.editName = catName
            this.editId = catId
            this.diasMes = diasMes
            this.horasDia = horasDia
            this.horasHombreMes = horasHombreMes
            this.costoTotalArea = costoTotalArea
            this.costoHoraHombre = costoHoraHombre
            this.numPersonas = numPersonas, 
            this.img = img
        }else{
          this.modalEdit = false
          this.editName = ''
            this.editId = ''
            this.diasMes = ''
            this.horasDia = ''
            this.horasHombreMes = ''
            this.costoTotalArea = ''
            this.costoHoraHombre = ''
            this.numPersonas = ''
            this.img = ''
        }
      },
      showModalDelete(catName, catId){
        if(this.modalDelete === false){
            this.modalDelete = true
            this.deleteName = catName
            this.deleteId = catId
        }else{
          this.modalDelete = false
        }
      },

      updateParent(){
        this.$emit('reloadData', true)
      },

      //Paginado
      setPages(){
        let numberOfPages = Math.ceil(this.areas.length / this.elementsPerPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
      },
      paginate(category) {
          let page = this.page;
          let perPage = this.elementsPerPage;
          let from = (page * perPage) - perPage;
          let to = (page * perPage);
          return  category.slice(from, to);
      },
      getPageNumber(){
          return this.pages.length
      }
    },
    beforeMount(){
      if(localStorage.getItem('token')){
        this.getAreas()
      }else{
        this.$router.push('/login')
      }
      
    },
}
</script>

<style>

</style>